import React from 'react';
import { Redirect } from 'react-router-dom';

function Utilities() {
    // Redirect to order return when clicking parent menu item
    return <Redirect to="/utilities/order-return" />;
}

export default Utilities;
